import { render, staticRenderFns } from "./AreaPivotIndex.vue?vue&type=template&id=6fadbb84"
import script from "./AreaPivotIndex.vue?vue&type=script&lang=js"
export * from "./AreaPivotIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports